module.exports = __webpack_public_path__ + "img/image7.13eae54.webp";